import BalanceComponent from '../BalanceComponent/BalanceComponent';
import TabBar from '../TabBar/TabBar';
import Footer from '../Footer/Footer';
import { Button, Icon } from 'lb-components';
import { PlusIcon } from '../../../assets/icons';
import classes from '../bottombar.module.scss';
import { UseUser } from 'lb-store/src/hooks';
import { useTranslation } from 'lb-store';

const Tabs = ({ setRoute, navigate, close }) => {
  const { t, i18n } = useTranslation();
  const { User } = UseUser();
  return (
    <>
      <BalanceComponent User={User} setRoute={setRoute} t={t} lang={i18n.language} navigate={navigate} />
      {/*{User?.data?.referral_enabled && (
        <div className={classes.inviteFriend}>
          <p>{t('მოიწვიე მეგობარი და მიიღე საჩუქარი')}</p>
          <div className={classes.buttonContainer}>
            <Button
              variant={'success'}
              onClick={() => setRoute('invite-friend')}
            >
              <Icon
                style={{
                  height: '2.3rem',
                  width: '2.3rem',
                  backgroundColor: '#fff',
                  marginRight: '0.8rem',
                }}
                Icon={PlusIcon}
                type={'vec'}
              />
              {t('მოიწვიე')}
            </Button>
          </div>
        </div>
      )}*/}

      <TabBar
        navigate={navigate}
        setRoute={setRoute}
        onSelectMenu={(e) => {
          setRoute(e);
        }}
      />
      <Footer close={close} />
    </>
  );
};
export default Tabs;
